import { render, staticRenderFns } from "./CreatesoInvoice.vue?vue&type=template&id=81ad3e82&scoped=true"
import script from "./CreatesoInvoice.vue?vue&type=script&lang=js"
export * from "./CreatesoInvoice.vue?vue&type=script&lang=js"
import style0 from "./CreatesoInvoice.vue?vue&type=style&index=0&id=81ad3e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ad3e82",
  null
  
)

export default component.exports